import { useMediaQuery } from 'react-responsive'

import { Header } from './Header'
import { HeaderMobile } from './HeaderMobile'
import { Footer } from './Footer'
import FooterMobile from './FooterMobile/FooterMobile'
import './DefaultLayout.scss'
import { ChuChay } from '../../component/ChuChay'
const IsMobile = () => {
  return useMediaQuery({ query: '(max-width: 767px)' })
}

function DefaultLayout ({ children }) {
  const isMobile = IsMobile()

  return (
    <div className={isMobile ? 'default_layout_mobile' : ''}>
      {isMobile ? <HeaderMobile /> : <Header />}
      {isMobile ? <div></div> : <ChuChay />}
      <div>{children}</div>
      {isMobile ? <FooterMobile /> : <Footer />}
    </div>
  )
}

export default DefaultLayout
